'use client';

import { useParams } from 'next/navigation';
import { FC, PropsWithChildren, useMemo } from 'react';

import { ScrollTopButton } from '@/components/buttons';
import { FilterGames } from '@/components/FilterGames';
import LobbySliderSkeleton from '@/components/skeletons/LobbySliderSkeleton';
import { useScrollTopBtn } from '@/hooks/scrollTopBtn';
import { PromotionsSlider } from '@/modules/lobby/components/PromotionsSlider';
import { RegistrationSlider } from '@/modules/lobby/components/RegistrationSlider';
import { useCommonStore } from '@/store';

import { ScSliderLayoutContent } from './styled';
import { ScContainer } from '@/styles/common';

export const LayoutRegBanner: FC<PropsWithChildren> = ({ children }) => {
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUser = useCommonStore.use.pendingUser();

  const { containerRef, gamesContainerRightOffset, isTop } = useScrollTopBtn();

  const { gameProvider, gameSubCategory, category } = useParams();

  const gamesFilterData = useMemo(() => {
    return {
      providerId:
        typeof gameProvider === 'string'
          ? decodeURIComponent(gameProvider)
          : undefined,
      subCategoryId:
        typeof gameSubCategory === 'string'
          ? decodeURIComponent(gameSubCategory)
          : undefined,
      categoryId:
        typeof category === 'string' ? decodeURIComponent(category) : undefined,
    };
  }, [category, gameProvider, gameSubCategory]);

  const slider = useMemo(() => {
    if (pendingUser) {
      return <LobbySliderSkeleton />;
    }

    return isAuthenticated ? <PromotionsSlider /> : <RegistrationSlider />;
  }, [pendingUser, isAuthenticated]);

  return (
    <>
      {slider}
      <ScSliderLayoutContent>
        <ScrollTopButton right={gamesContainerRightOffset} isTop={isTop} />
        <FilterGames {...gamesFilterData} />

        {children}
      </ScSliderLayoutContent>
      <ScContainer ref={containerRef} />
    </>
  );
};
